import { useState, useCallback } from 'react';
import { AudioBus, type SoundEvent } from '../utils/AudioBus';

// Fachada fina sobre o AudioBus (barramento único). Mantém a mesma API que as
// telas já usam (playHover/playClick/playSuccess/playError/toggleMute) e
// adiciona playBack/playBlocked. Cada chamada destrava o áudio (necessário no
// primeiro gesto em iOS/Android) e delega ao AudioBus.
// Mapa telas → evento canônico em docs/MAPA-DE-SOM.md.

let globalMuted = false;

export function useGameAudio() {
  const [isMuted, setIsMuted] = useState(globalMuted);

  const toggleMute = () => {
    globalMuted = !globalMuted;
    AudioBus.setMuted(globalMuted);
    setIsMuted(globalMuted);
  };

  const play = useCallback((ev: SoundEvent) => {
    AudioBus.unlock();
    AudioBus.play(ev);
  }, []);

  return {
    isMuted,
    toggleMute,
    playHover: () => play('ui.hover'),
    playClick: () => play('ui.click'),
    playBack: () => play('ui.back'),
    playBlocked: () => play('ui.blocked'),
    playSuccess: () => play('feedback.correct'),
    playError: () => play('feedback.wrong'),
  };
}
